import { message } from "antd";
import { setCookie, deleteCookie, getCookie } from "cookies-next";
import { getMemberData } from "../pages/api/modules/User";
import { COUNTRY_VARIABLES } from "@/constant/constantVar";

export const setUserData = (data, reload = true) => {
  setCookie("HireSide_Members_AccessToken", data?.token, { maxAge: 60 * 60 * 24 * 7 });
  setCookie("HireSide_Members_UserInfo", JSON.stringify(data?.userInfo), { maxAge: 60 * 60 * 24 * 7 });
  localStorage.setItem("HireSide_Members_AccessToken", data?.token);
  localStorage.setItem("HireSide_Members_UserInfo", JSON.stringify(data?.userInfo));
  if (reload) {
    signIN();
  }
};

export const Company = {
  getCompany: () => {
    let data;
    try {
      data = getCookie("companyCode");
    } catch (error) {
      data = null;
    }
    return data;
  },
  setCompany: (data, reload = false) => {
    setCookie("companyCode", data, { maxAge: 60 * 60 * 24 * 7 });
    if (reload) {
      location.reload();
    }
  },
};

export const Companies = {
  getCompanies: () => {
    let data;
    try {
      data = getCookie("companies");
    } catch (error) {
      data = null;
    }
    return data;
  },
  setCompany: (data, reload = false) => {
    setCookie("companies", data, { maxAge: 60 * 60 * 24 * 7 });
    if (reload) {
      location.reload();
    }
  },
};
export const EmployerRoles = {
  getEmployerRoles: () => {
    let data;
    try {
      data = getCookie("employerRoles");
    } catch (error) {
      data = null;
    }
    return data;
  },
  setEmployerRoles: (data, reload = false) => {
    setCookie("employerRoles", data, { maxAge: 60 * 60 * 24 * 7 });
    if (reload) {
      location.reload();
    }
  },
};

export const JobStatusFilters = {
  getJobStatusFilters: () => {
    let data;
    try {
      data = getCookie("JobStatusFilters");
    } catch (error) {
      data = null;
    }
    return data;
  },
  setJobStatusFilters: (data, reload = false) => {
    setCookie("JobStatusFilters", data, { maxAge: 60 * 60 * 24 * 7 });
    if (reload) {
      location.reload();
    }
  },
};

export const CandidateCheckboxFilters = {
  getCandidateCheckboxFilters: () => {
    let data;
    try {
      data = getCookie("CandidateCheckboxFilters");
    } catch (error) {
      data = null;
    }
    return data;
  },
  setCandidateCheckboxFilters: (data, reload = false) => {
    setCookie("CandidateCheckboxFilters", data, { maxAge: 60 * 60 * 24 * 7 });
    if (reload) {
      location.reload();
    }
  },
};




export const getCountry = () => {
  let data;
  try {
    data = getCookie("countryCode");
  } catch (error) {
    data = null;
  }

  if (!data) {
    data = COUNTRY_VARIABLES.countryCode;
  }
  
  return data;
};

export const setCountry = (data, reload = false) => {
  setCookie("countryCode", data, {  maxAge: 60 * 60 * 24 * 7 });
  localStorage.setItem("countryCode", data);
  if (reload) {
    location.reload();
  }
};

export const isUserLogin = () => {
  return (
      localStorage.getItem("HireSide_Members_AccessToken") && localStorage.getItem("HireSide_Members_UserInfo") !== null
  );
};

export const getUserToken = () => {
  return localStorage.getItem("HireSide_Members_AccessToken");
};

export const setUserToken = (data) => {
  setCookie("HireSide_Members_AccessToken", data?.token, { maxAge: 60 * 60 * 24 * 7 });
  localStorage.setItem("HireSide_Members_AccessToken", data?.token);
};

export const getUserInfo = () => {
  let data;
  try {
    return JSON.parse(localStorage.getItem("HireSide_Members_UserInfo"));
  } catch (error) {
    return {};
  }
};

export const setUserInfo = (data, reload = false) => {
  localStorage.setItem("HireSide_Members_UserInfo", JSON.stringify(data));
  if (reload) {
    signIN();
  }
};

export const singOut = () => {
  localStorage.removeItem("HireSide_Members_AccessToken");
  localStorage.removeItem("HireSide_Members_UserInfo");
  deleteCookie("HireSide_Members_AccessToken");
  deleteCookie("HireSide_Members_UserInfo");
};

export const signIN = async () => {
  const LoginEvent = new Event("userStateChanges");
  window.dispatchEvent(LoginEvent);
};

export const signOutEvent = async () => {
  const reauth = new Event("reauth");
  window.dispatchEvent(reauth);
};

export const unClickable = (e) => {};

export const getData = async () => {
  const userToken = getUserToken();
  const res = await getMemberData();
  if (res?.Status === 1) {
    setUserData({ token: userToken, userInfo: res.Data.MemberInfo });
  }
};

export const ToFromDateComparision = (fromDate, toDate) => {
  const from = fromDate?.$isDayjsObject ? fromDate.$d : fromDate?._d;
  const to = toDate?.$isDayjsObject ? toDate.$d : toDate?._d;
  to?.setHours(0, 0, 0, 0);
  from?.setHours(0, 0, 0, 0);
  if ((to && from > to) || from?.getTime() == to?.getTime()) {
    return false;
  }
  return true;
};

export const CompareWithToday = (date) => {
  const dt = date?.$isDayjsObject ? date.$d : date?._d;
  const today = new Date();
  dt?.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  if (dt > today) {
    return true;
  }
  return false;
};

export const parseTimeZoneString = (timeZoneString) => {
  const regex = /\(GMT([+-]?\d{2}:\d{2})?\)\s(.+)/;
  const matches = timeZoneString.match(regex);
  if (matches && matches.length === 3) {
    let offset = matches[1] || "00:00";
    let location = matches[2];
    return { offset, location };
  } else {
    return { error: "Invalid format" };
  }
};
export const CompanyCodeGenerator = (name) => name && name.trim().split(" ").join("").toLowerCase();

export function getFirstRouteSegment(url) {
  const baseUrl = url.split("?")[0];
  const segments = baseUrl.split("/").filter((segment) => segment !== "");
  if (segments.length > 0) {
    return segments[0];
  } else {
    return null;
  }
}

export const candidateRoute = (route) => {
  const routes = ["companies", "jobs"];
  return routes.includes(route);
};

export const baseUrl = (country = "") => {
  const userLocation = getCountry();
  let url = "";
  if (country) {
    url = `${process.env.PROTOCOL}${country}.${process.env.DOMAIN}`;
  } else if (userLocation) {
    url = `${process.env.PROTOCOL}${userLocation}.${process.env.DOMAIN}`;
  } else {
    url = `${process.env.PROTOCOL}${process.env.DOMAIN}`;
  }
  return url;
};


export const candidateApplyFormData = {
  getCandidateApplyFormData: () => {
    let data;
    try {
      data = getCookie("CandidateApplyFormData");
    } catch (error) {
      data = null;
    }
    return data;
  },
  setCandidateApplyFormData: (data, reload = false) => {
    setCookie("CandidateApplyFormData", data, { maxAge: 60 * 60 * 24 * 7 });
    if (reload) {
      location.reload();
    }
  },
};

export const CompanyLogo = {
  getCompanyLogo: () => {
    let data;
    try {
      data = getCookie("companyLogo");
    } catch (error) {
      data = null;
    }
    return data;
  },
  setCompanyLogo: (data, reload = false) => {
    setCookie("companyLogo", data, { maxAge: 60 * 60 * 24 * 7 });
    if (reload) {
      location.reload();
    }
  },
};